import { createContext } from 'react';

type ChatContextType = {
  chatId?: string;
  setChatId: (chatId?: string) => void;
};

export const chatContext = createContext<ChatContextType | undefined>(undefined);
